import { render } from "./StudentPlace.vue?vue&type=template&id=0598d3de"
import script from "./StudentPlace.vue?vue&type=script&lang=js"
export * from "./StudentPlace.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__